import { css } from "styled-components/macro";

export const GridSpacingFix = css`
  margin: 0;
  padding: 0 !important;
`;
